<script lang="ts">
    import { UserRole } from "@frontend/walletapi";
    import AddUserForm from "./AddUserForm.svelte";
    import { me } from "@frontend/user";
    
    export let dismiss: () => void;
</script>

<AddUserForm role={UserRole.Player}  dismiss={dismiss} />
